import React, { useState } from 'react';

import { RelativityListsModal } from './relativity-lists-dialog';
import { RelativityWorkspacesModal } from './relativity-workspaces-dialog';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { RelativityWorkspaceType } from '@/api/types/backend-dto-types';

interface RelativityIntegrationModalProps {
  matterId?: string; // 2.0: matter-level
  caseId?: string; // Legacy: case-level
  onClose: () => void;
  unpackEmail: boolean;
  deduplicateDocuments: boolean;
  fallbackToExtractedText: boolean;
  onOpenImportSettings: () => void;
}

type ModalStep = 'workspaces' | 'lists';

export const RelativityIntegrationModal: React.FC<RelativityIntegrationModalProps> = ({
  matterId,
  caseId,
  onClose,
  unpackEmail,
  deduplicateDocuments,
  fallbackToExtractedText,
  onOpenImportSettings,
}) => {
  const [currentStep, setCurrentStep] = useState<ModalStep>('workspaces');
  const [selectedWorkspace, setSelectedWorkspace] = useState<RelativityWorkspaceType | null>(null);
  const { data: matter } = useGetMatterV2(matterId);

  const handleSelectWorkspace = (workspace: RelativityWorkspaceType) => {
    setSelectedWorkspace(workspace);
    setCurrentStep('lists');
  };

  const handleBackToWorkspaces = () => {
    setCurrentStep('workspaces');
    setSelectedWorkspace(null);
  };

  if (currentStep === 'workspaces') {
    return (
      <RelativityWorkspacesModal
        onSelectWorkspace={handleSelectWorkspace}
        onClose={onClose}
        linkedWorkspaceId={matter?.relativityWorkspaceId ?? null}
      />
    );
  }

  if (currentStep === 'lists' && selectedWorkspace) {
    return (
      <RelativityListsModal
        workspace={selectedWorkspace}
        matterId={matterId}
        caseId={caseId}
        onBack={handleBackToWorkspaces}
        onClose={onClose}
        unpackEmail={unpackEmail}
        deduplicateDocuments={deduplicateDocuments}
        fallbackToExtractedText={fallbackToExtractedText}
        onOpenImportSettings={onOpenImportSettings}
      />
    );
  }

  return null;
};
